module.exports = __webpack_public_path__ + "static/BTP_profile-2cd400b9619b128673a24cd34a1b6d16.png";